import React, { FC } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { MobileSidebar } from 'app/components/Sidebar/MobileSidebar';
import { RightSidebar } from 'app/components/Sidebar/RightSidebar';

export const ProfileMenuContainer: FC = () => {
  const theme = useTheme();
  const isFullScreen = useMediaQuery(theme.breakpoints.up('lg'));

  return <>{isFullScreen ? <RightSidebar /> : <MobileSidebar />}</>;
};
